<template>
  <v-autocomplete
    :value="value"
    :disabled="loading"
    :items="items"
    chips
    deletable-chips
    :label="label"
    item-text="companyName"
    item-value="id"
    v-bind="$attrs"
    @change="select"
    return-object
  >
    <template v-slot:selection="data">
      <v-chip
        v-bind="data.attrs"
        :input-value="data.selected"
        close
        @click="data.select"
        @click:close="clear"
      >
        {{ data.item.companyName }}, {{ data.item.town }}
      </v-chip>
    </template>
    <template v-slot:item="data">
      <v-list-item-content>
        <v-list-item-title
          >{{ data.item.companyName }}, {{ data.item.town }}
        </v-list-item-title>
        <v-list-item-subtitle> {{ data.item.comment }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
  </v-autocomplete>
</template>
<script>
import { defineComponent } from "vue";
export default defineComponent({
  name: "InventoryCompanyPicker",
  props: {
    value: Object,
    label: {
      type: String,
      default: "Firma",
    },
    nullValue: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      items: [],
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      this.items = await this.apiList({ resource: "inventory/company" });
      this.loading = false;
    },
    clear() {
      this.$emit("input", this.nullValue);
    },
    select($event) {
      this.$emit("input", $event);
    },
  },
  async created() {
    this.getData();
  },
});
</script>
